// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q4kx","index":"styles_index__3FC_G"};